import { SVGProps, Ref, forwardRef } from 'react';

export const ChartLineFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 1C2.375 1 1 2.375 1 12s1.375 11 11 11 11-1.375 11-11S21.625 1 12 1m7.273 8.5L18 8.227l-5 5-3.5-3.5L4.727 14.5 6 15.773l3.5-3.5 3.5 3.5z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ChartLineFilledSize24Glyph.displayName = 'ChartLineFilledSize24Glyph';
